import { Component, Input } from "@angular/core";
import { MagicCardForStats } from "@apiserver-rest/ponder-data-client-base";
import { ChartBaseComponent } from "@ponder-shared/charts/chart-base.component";
import { isMobileScreen } from "@ponder-shared/utils/screenBreakpoints";
import { BaseChartDirective } from "ng2-charts";
import { environment } from "../../../../../environments/environment";

@Component({
    selector: "magic-collection-age-chart",
    imports: [BaseChartDirective],
    templateUrl: "./magic-collection-age-chart.component.html"
})
export class MagicCollectionAgeChartComponent extends ChartBaseComponent {
    @Input({ required: true }) public magicCardStats!: MagicCardForStats[];

    private cardsPerYear!: number[];

    public override ngOnInit(): void {
        this.dataLabel = "Cards";
        this.xGridLineVisible = false;
        this.yGridLineVisible = false;
        this.yGridBorderVisible = false;
        this.xLabelColor = "#888";
        this.yLabelColor = "#888";
        this.lineColor = environment.colors.chart.blue;
        this.backgroundColor = environment.colors.chart.blue;
        this.lineWidth = 0;
        this.lineBorderRadius = 3;

        super.ngOnInit();

        this.compileData();
        this.updateChartData();
    }

    public isMobileScreen(): boolean {
        return isMobileScreen();
    }

    private compileData(): void {
        var thisYear = new Date(Date.now()).getFullYear();
        var totalYears = (thisYear - 1993) + 1;

        this.cardsPerYear = Array(totalYears).fill(0);

        this.magicCardStats.forEach(mc => {
            var index = mc.releaseDate.getFullYear() - 1993;
            this.cardsPerYear[index] += mc.count + mc.specialCount;
        });
    }

    private updateChartData(): void {
        var labels: string[] = [];

        this.cardsPerYear.forEach((value: number, index: number, arr: number[]) => {
            labels.push(`${1993 + index}`);
            this.addDataPoint(arr[index]);
        });

        this.setLabels(labels);
    }
}